module.exports = __webpack_public_path__ + "img/performanceOfDiamonds@2x.0601267.webp";